import BannersLink from '@components/BannersLink';
import LoadingSkeleton from '@components/LoadingSkeleton';
import type { MainSlideBannerT } from '@root/src/types';
import { preparePriceFloatObject } from '@utils/floatNumbers';
import type { FC } from 'react';
import { LazyLoadImage } from '@components/reactLazyLoadImageComponent';
import './index.scss';

interface MainSlideBannerProps {
  item: MainSlideBannerT;
  index?: number;
  loadImage?: boolean;
  fetchPriority?: 'high' | 'low' | 'auto';
}

export const MainSlideBannerLoading: FC = () => (
  <LoadingSkeleton className='main-slide-banner !rounded-[12px]' />
);

export const MainSlideBanner: FC<MainSlideBannerProps> = ({
  item,
  index = 0,
  loadImage,
  fetchPriority
}) => {
  if (!item) {
    return null;
  }

  let oldPrice, newPrice, percentDiscount;
  if (item.catalogItems) {
    oldPrice = preparePriceFloatObject(
      item.catalogItems[0]?.priceBlockWeightPrice
        ? item.catalogItems[0]?.oldPriceField
        : item.catalogItems[0]?.oldPriceField2 ?? null
    );
    newPrice = preparePriceFloatObject(
      item.catalogItems[0]?.priceBlockWeightPrice
        ? item.catalogItems[0]?.currentPriceField
        : item.catalogItems[0]?.currentPriceField2
    );
    percentDiscount =
      typeof item?.catalogItems?.[0]?.oldPrice === 'number'
        ? Math.round(
            (((item?.catalogItems?.[0]?.oldPrice || 0) -
              (item?.catalogItems?.[0]?.price || 0)) /
              (item?.catalogItems?.[0]?.oldPrice || 0)) *
              100
          )
        : null;
  }
  const imageSrc =
    item?.fileItem?.cacheItem?.[0]?.filePath ||
    (item?.file_new?.length === 0 ? item.bannerFilePath : item.file_new);
  const visibleByDefault =
    loadImage === true || Boolean(item.catalogItems) || index === 0;
  const bannerImage =
    loadImage === false ? null : (
      <LazyLoadImage
        className='main-slide-banner__img'
        src={imageSrc}
        visibleByDefault={visibleByDefault}
        alt={item.title}
        fetchPriority={fetchPriority ?? (index === 0 ? 'high' : undefined)}
      />
    );
  return (
    <BannersLink
      link={item?.link ?? ''}
      className='main-slide-banner'
      ariaLabel={item?.title ?? ''}
    >
      {item.catalogItems ? (
        <div className='newBanner'>
          <div className='informationBlock'>
            <div className='title'>{item.title}</div>
            <div className='comment'>
              {item.product_title || item.catalogItems[0]?.title}
            </div>
          </div>
          <div className='priceBlock'>
            <div className='currentPrice'>
              {oldPrice?.wholePart && item?.catalogItems?.[0].oldPrice ? (
                <div className='oldPrice'>{oldPrice.wholePart} ₽</div>
              ) : null}
              <div className='newPrice'>
                {newPrice.wholePart}
                {newPrice?.floatPart && (
                  <span className='newPriceFloat'>,{newPrice.floatPart}</span>
                )}
                <span className='newPriceFloat'>
                  {' '}
                  ₽
                  {!item.catalogItems[0]?.priceBlockWeightPrice
                    ? null
                    : item.catalogItems[0]?.measureItem?.symbol
                    ? `/${item.catalogItems[0]?.measureItem?.symbol}`
                    : null}
                </span>
              </div>
            </div>
            {oldPrice?.wholePart && item?.catalogItems?.[0].oldPrice ? (
              <div className='percentDiscount'>-{percentDiscount}%</div>
            ) : null}
          </div>
          {bannerImage}
        </div>
      ) : (
        bannerImage
      )}
    </BannersLink>
  );
};
